// extracted by mini-css-extract-plugin
module.exports = {"image":"Artwork_image__i15QZ","waveAnimation":"Artwork_waveAnimation__iLfjr","marquee":"Artwork_marquee__ghR2c"};